var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import { generateId } from '../utils';
function isInTheWeek(date, selectedDate) {
    var monday = moment(selectedDate).weekday(1);
    var sunday = moment(selectedDate).weekday(7);
    return date.isBetween(monday, sunday, 'day', '[]');
}
export function processRotations(rotations, selectedDate) {
    if (!(rotations === null || rotations === void 0 ? void 0 : rotations.length))
        return [];
    return rotations.reduce(function (acc, rotation) {
        var _a;
        var baseRotation = __assign(__assign({}, rotation), { id: rotation.id || generateId(), serviceStatus: (_a = rotation.serviceStatus) === null || _a === void 0 ? void 0 : _a.replaceAll('_new', '').replaceAll('_future', '') });
        // Override with specific date
        if (rotation.serviceStatus.startsWith('override')) {
            // Override with holiday
            acc.push(__assign(__assign({}, baseRotation), { show: isInTheWeek(moment(rotation.date), selectedDate) }));
            return acc;
        }
        // Otros casos (available, no_service, store_hours, etc.)
        acc.push(__assign(__assign({}, baseRotation), { show: true }));
        return acc;
    }, []);
}
export function updateRotation(rotations, rotation, date) {
    var newRotation = rotation || [];
    if (newRotation.serviceStatus.includes('no_service')) {
        delete newRotation.primaryTechnician;
        delete newRotation.backupTechnician;
        delete newRotation.finalTechnician;
    }
    var updatedRotations = rotations
        .filter(function (rot) { var _a; return !((_a = rot === null || rot === void 0 ? void 0 : rot.id) === null || _a === void 0 ? void 0 : _a.startsWith(rotation.id)); })
        .concat(newRotation);
    return processRotations(updatedRotations, date);
}
export function deleteRotation(rotations, rotationId) {
    return rotations === null || rotations === void 0 ? void 0 : rotations.filter(function (rotation) { var _a; return !((_a = rotation === null || rotation === void 0 ? void 0 : rotation.id) === null || _a === void 0 ? void 0 : _a.startsWith(rotationId)); });
}
export function deleteAllRotations(rotations) {
    return rotations === null || rotations === void 0 ? void 0 : rotations.filter(function (rotation) { return rotation === null || rotation === void 0 ? void 0 : rotation.serviceStatus.startsWith('store_hours'); });
}
//# sourceMappingURL=Rules.js.map